<template>
  <div>
    <!-- Section 1: Full Window Height -->
    <div class="slider-container">

      <swiper
        :modules="modules"
        class=""
        :autoplay="{
          delay: 1500,
          disableOnInteraction: false
        }"
      >
      <swiper-slide v-for="(image, index) in images" :key="index">
        <img :src="image" alt="Slider Image" class="slider-image" />
      </swiper-slide>
      </swiper>

      <!-- Text Overlay -->
      <div class="text-overlay">
        <div>
          <h1>Clean Water. Bright Futures.</h1>
          <p>Advising companies on strategy, growth plans, and market positioning.</p>
        </div>
      </div>
      
    </div>

    <!-- Section 2: -->
    <div class="section-2" v-intersection="onIntersect">
      <div class="container my-5 main-section">
        <div class="row align-items-center">
          <!-- Text Section -->
          <div class="col-md-6">
            <div class="text-center text-md-start text-section">
              <!-- Logo -->
              <div class="mb-4">
                <img src="@/assets/home-pg-img/pratima-v-card.png" alt="Logo" class="img-fluid" height="150" width="150" />
              </div>
              <!-- Title -->
              <h1 class="display-5 fw-bold mb-4">“Sustaining Life, <br>
                Drop by Drop” </h1>
              <!-- Description -->
              <p class="text-muted mt-3 pl-5">
                Founded in 2016, Pratima Construction and Consultancy drives innovation in water supply, drainage, and infrastructure, delivering excellence through transformative projects like the Jal Jeevan Mission.
              </p>
              <!-- Button -->
              <a href="/about-us" class="btn btn-outline-secondary btn-lg mt-3 rounded-5 learn-more-btn">Learn More</a>
            </div>
          </div>

          <!-- Image Section -->
          <div class="col-md-6 d-flex justify-content-center align-items-center">
            <img
              src="@/assets/home-pg-img/About-image.jpg"
              alt="Team Discussion"
              class="img-fluid rounded-5 image-fill-height"
            />
          </div>
        </div>

        <!-- Featured Section -->
        <div class="row text-center featured-section">
          <div class="d-flex justify-content-center gap-5 row section-2-counts">
            <count-up class="text-dark fw-bold f1 col-2" :end-val="35" :options="options"></count-up>
            <count-up class="text-dark fw-bold f1 col-2" :end-val="15" :options="options"></count-up>
            <count-up class="text-dark fw-bold f1 col-2" :end-val="10" :options="options"></count-up>
            <count-up class="text-dark fw-bold f1 col-2" :end-val="6" :options="options"></count-up>
          </div>
          <div class="d-flex justify-content-center gap-5 row section-2-titles">
            <span class="text-dark f2 col-2" v-for="(title, index) in countTitles" :key="index">{{ title }}</span>
          </div>
        </div>
      </div>
    </div>
      <div class="section-3">
        <div class="row">
          <!-- Text Section -->
          <div class="col-md-6 col-sm-12 d-flex justify-content-center align-items-center order-lg-1 order-md-1 order-sm-2 order-xs-2">
            <div class="text-content ms-5 ">
              <p>
                Mr. Sahebrao Shridhar Gade, a visionary leader with over 30 years of experience, has made significant contributions to water supply and drainage infrastructure projects across Maharashtra. Beginning his career with Maharashtra Jeevan Pradhikaran in 1985, he was honored with the prestigious Best Engineering Award in 2012 for his dedication to excellence. After retiring in 2015, he continues to lead Pratima Construction with a focus on innovative and sustainable solutions, driving the firm's success in large-scale infrastructure projects through his strategic vision and hands-on expertise.
              </p>
            </div>
          </div>

          <!-- Image Section -->
          <div class="col-md-6 col-sm-12 d-flex flex-column justify-content-center align-items-center order-lg-2 order-md-2 order-sm-1 order-xs-1">
            <div class="section-3-image-container">
              <img
                src="@/assets/home-pg-img/Mr.Gade.jpg"
                alt="Team Discussion"
                class="img-fluid rounded section-3-image"
              />
            </div>
            <!-- Name and Role -->
            <div class="mt-4 mb-4 text-center section3-name">
              <h4>MR. SAHEBRAO GADE</h4>
              <span>Consultant & Engineer</span>
            </div>
          </div>
        </div>
      </div> 

    <!-- section 4 -->
    <div class="section-4">
      <div class="services row justify-content-center align-items-center">
        <!-- Title Column -->
        <div class="col-lg-4 col-sm-12 fw-bold">
          <h5>Services</h5>
        </div>

        <!-- Text Column -->
        <div class="col-lg-7 col-sm-12 fw-light pt-lg-4 text-lg-end text-sm-center">
          <p>
            Our services ensure clean, reliable, and efficient water distribution for urban, rural, and industrial needs.
          </p>
        </div>
      </div>

      <div class="d-flex flex-wrap justify-content-center custom-card mt-4">
        <div class="card-container" v-for="(service, index) in servicesData" :key="index">
          <div class="card text-start">
            <img :src="service.image" class="card-img-top" :alt="service.alt" />
            <div class="card-body">
              <h5 class="card-title fw-bold">{{ service.title }}</h5>
              <p class="card-text fw-light">{{ service.text }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center mt-5">
          <a href="/services" class="btn btn-outline-secondary btn-lg rounded-5 know-more-btn">Know More</a>
      </div>
    </div>

    <!-- section 5 -->
     <div class="section-5">
        <div class="marquee-container">
          <div class="marquee-content">
            <img src="@/assets/home-pg-img/Gallery-photo.jpg" alt="Scrolling Image" />
          </div>
        </div>
      </div>
        <div class="single-image-slider">
          <div class="marquee-container-small">
            <div class="marquee-content-small">
              <div
                v-for="(image, index) in duplicatedImages"
                :key="index"
                class="marquee-item-small"
              >
                <img :src="image" alt="Image" class="marquee-image-small" />
              </div>
            </div>
          </div>

        </div>

     <!-- section 6 -->
      <div class="section-6">
        <div class="reviews">
          <div class="title">
            <h5 class="fw-bold text-start">Reviews</h5>
          </div>
          <div class="d-flex flex-row custom-card custom-swiper rounded-5 gap-5">
            <swiper
              class="swiper"
              :modules="modules"
              :space-between="30"
              :slides-per-view="3"
              :pagination="{ clickable: true }"
              :autoplay="{
                delay: 1000,
                disableOnInteraction: false
              }"
              :breakpoints="{
                320: { slidesPerView: 1, spaceBetween: 30 },
                768: { slidesPerView: 2, spaceBetween: 41 },
                1200: { slidesPerView: 3, spaceBetween: 30 }
              }"
            >
              <swiper-slide v-for="(reviews, index) in reviewsData" :key="index">
                <div class="card-container">
                  <div class="card text-center rounded-5">
                    <img :src="reviews.image" class="card-img-top rounded-top-5" :alt="reviews.alt" />
                    <div class="card-body">
                      <h5 class="card-title fw-bold">{{ reviews.title }}</h5>
                      <p class="card-text fw-light">{{ reviews.text }}</p>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
         
          </div>
        </div>
      </div>
  </div>

</template>


<script>
import CountUp from 'vue-countup-v3';
// import SwiperClass, { Pagination } from 'Swiper';
import { Swiper, SwiperSlide } from 'swiper/vue'; // Import Swiper Vue components
import 'swiper/css'; // Import Swiper base styles
import 'swiper/css/pagination'; // Import Swiper pagination styles
import { Pagination, FreeMode } from 'swiper/modules'; // Import Swiper modules
import { Autoplay } from 'swiper/modules';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

export default {
  components:{
    CountUp,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      imageSrc: require('@/assets/images/gallery-photo.jpg'),
      sahebraoImg: require('@/assets/images/sahebrao-gade-2.jpg'),
      modules: [Pagination, FreeMode,Autoplay], // Swiper modules are used here
      reverseDirection: false, // Track scroll direction
      images: [
        require('@/assets/home-pg-img/Banner.jpg'),
        require('@/assets/home-pg-img/Banner-1.jpg'),
        require('@/assets/home-pg-img/Banner-3.jpg'),
      ],
      homeGallary:[
        require('@/assets/home-pg-img/gallary-mobile/gallery1.jpeg'),
        require('@/assets/home-pg-img/gallary-mobile/gallery2.jpg'),
        require('@/assets/home-pg-img/gallary-mobile/gallery3.jpeg'),
        require('@/assets/home-pg-img/gallary-mobile/gallery4.jpeg'),
        require('@/assets/home-pg-img/gallary-mobile/gallery5.jpeg'),
      ],
      options: {
        enableScrollSpy: true,
        duration: 10
      },
      servicesData:[
      {
          image: require("@/assets/home-pg-img/water-supply.jpg"), // Replace with actual image path
          alt: "Image 1",
          title: "Water Supply Schemes",
          text: "Our Water Supply Schemes are dedicated to providing clean and pure drinking water to meet the essential needs of individuals, households, and businesses. We specialize in designing, installing, and maintaining efficient water."
        },
        {
          image: require("@/assets/home-pg-img/Elevated.png"),
          alt: "Image 2",
          title: "Elevated Service Reservoir",
          text: "A high-rise water storage structure designed to store treated water and ensure adequate water supply with sufficient pressure for distribution. Built above ground level, it utilizes gravitational force to facilitate the flow of water across urban and rural areas."
        },
        {
          image: require("@/assets/home-pg-img/sewage.png"),
          alt: "Image 3",
          title: "Sewage Water Treatment",
          text: "We offer comprehensive Sewage Water Treatment Plant (STP) services to ensure the effective treatment and management of wastewater. "
        },
     
      ],

      reviewsData:[
      {
          image: require("@/assets/i1.jpg"), // Replace with actual image path
          alt: "Image 1",
          title: "Ashley Robinson",
          text: "I recently hired and was highly impressed with their support and expertise."
        },
        {
          image: require("@/assets/i1.jpg"),
          alt: "Image 2",
          title: "Sarah Jackson",
          text: "I recently hired and was highly impressed with their support and expertise."
        },
        {
          image: require("@/assets/i1.jpg"),
          alt: "Image 3",
          title: "Jay Rutherford",
          text: "I recently hired and was highly impressed with their support and expertise."
        },
        {
          image: require("@/assets/i1.jpg"),
          alt: "Image 3",
          title: "Jay Rutherford",
          text: "I recently hired and was highly impressed with their support and expertise."
        }
      ],
      currentImage: 0,
      sliderInterval: null,
      targetCounts: [35, 15, 10, 6], // Target values for each counter
      currentCounts: [0, 0, 0, 0],   // Animated values to display
      countTitles: ["Experience", "Projects", "Cities", "Clients"], // Titles for each count
      animationDuration: 2000,  
    };
  },
  mounted() {
    // this.startSlider();
  },

  computed: {
    // Duplicate images for seamless scrolling
    duplicatedImages() {
      return [...this.homeGallary, ...this.homeGallary]; // Append the same images at the end
    },
  },


};
</script>

  <style scoped>

  /* section 1 */
  .slider-container {
    position: relative;
    width: 100%;
    height: 90vh; /* Full viewport height */
    overflow: hidden;
    z-index: 1; /* Lower layer */
  }

  .slider-container .swiper{
    height: 90vh !important;
  }

  @media (max-width:567px) {
    .text-overlay h1{
      font-size: 39px !important;
      max-width: 69% !important;
    }

    .text-overlay p {
      font-size: 16px !important;
    }
    
}
@media (max-width:460px) {
  .text-overlay h1{
      font-size: 35px !important;
    }

    .text-overlay p {
      font-size: 16px !important;
    }
}

@media (max-width:413px) {
  .text-overlay h1{
      font-size: 35px !important;
      
    }

    .text-overlay p {
      font-size: 16px !important;
    }
}

@media (max-width:371px) {
  .text-overlay h1{
      font-size: 32px !important;
      
    }
    .text-overlay p {
      font-size: 15px !important;
    }
}



  /* Image Styling */
  .slider-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* Text Overlay */
  .text-overlay {
    position: absolute;
    bottom: 12%; /* Adjusted for precise placement */
    left: 10%;   /* Padding from the left */
    color: white;
    text-align: left;
    text-shadow: 0px 4px 6px rgba(0, 0, 0, 0.7);
    z-index: 2;
    max-width: 40%; /* Ensures text doesn’t span too far horizontally */
  }

  .text-overlay h1 {
    font-family: 'Archivo';
    font-weight: 900;
    font-size: 48px;
    line-height: 142%;
    color: #fff;
    max-width: 62%;
  }

  .text-overlay p {
    font-size: 20px; /* Smaller than the header */
    margin: 15px 0;    /* Creates space between the header and button */
    font-weight: 600;
    line-height: 150%;
    color: #dee1e6;
    font-family: 'Inter';
    font-weight: 600;
    max-width: 70%;
  }

  @media (max-width: 1302px) {
    .text-overlay {
      max-width: 100%;
    }
  }

  /* Fade, Zoom, and Slide Animation */ 
  .fade-zoom-slide-enter-active,
  .fade-zoom-slide-leave-active {
    transition: opacity 1s ease-in-out, transform 1s ease-in-out;
  } 
  .fade-zoom-slide-enter {
    opacity: 0;
    transform: scale(1.1) translateX(50px); /*Zoom in and slide right*/
  }
  .fade-zoom-slide-leave-to {
    opacity: 0;
    transform: scale(1) translateX(-50px); /* Reset zoom and slide left */
  }

  /* Dots Container */
  .dots-container {
    position: absolute;
    bottom: 10%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    z-index: 3;
  }

  .dot {
    width: 12px;
    height: 12px;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    cursor: pointer;
    /* transition: background-color 0.3s; */
  }

  .dot.active {
    background-color: white;
  }


  /* section 2 */

  .main-section{
    /* margin-top: 22vh !important; */
    width: 100%;
    height: auto; /* Full viewport height */
    overflow: hidden;
  }

  .section-2 {
    position: relative;
    z-index: 2; /* Higher layer, ensures it appears above Section 1 */
    padding-top: 2rem; 
    background-color: #fff;
  }

  .featured-section{
    margin-top: 9vh !important;
    background: #F3F4F6;
    width: auto;
    height: 163px;
    top: 1563px;
    left: 132px;
    border-radius: 32px;
  }

  .featured-section p{
    padding-top: 25px;
    font-family: 'Inter';
    font-size: 20px;
    font-weight: 400;
    color: #424856;
  }

  .featured-section .f1 {
    font-family: 'Inter';
    font-weight: 900;
    font-size: 40px;
    line-height: 100%;
    letter-spacing: 0.05em;
    text-align: center;
    color: #000;
  }

  .featured-section .f2 {
    font-family: 'Inter';
    font-weight: 400;
    font-size: 30px;
    line-height: 133%;
    letter-spacing: 0.05em;
    text-align: center;
    color: #000;
  }

  .section-2-titles{
    margin-top: 0px;
  }

  .section-2-counts{
    margin-top: 3rem;
  }


  .text-section h1 {
    color: #333;
  }
  .text-section p {
    font-size: 1rem;
    color: #666;
    line-height: 1.6;
    padding-right: 1vh;
  }

  .section-2-counts span {
    transition: transform 0.3s ease, color 0.3s ease;
  }
  .section-2-counts span:hover {
    transform: scale(1.2);
    color: #333;
  }

  @media (max-width:767px) {
    .text-section{
      text-align: left !important;
    }
    .learn-more-btn{
      margin-bottom: 20px;
    }

    .featured-section{
      display: none;
    }

    .main-section{
      height:100% !important;
    }

    .section-3{
      height:100% !important;
    }

  }
  @media (max-width:575px) {
    .main-section{
      padding: 0px 5vh;
    }
    .text-section{
      padding-left: 2vh;
    }
  }

  /* Section 3 */

  .section-3 {
  margin-top: 10vh;
  width: 100%;
  height: auto;
  background: #166590;
  border-radius: 48px;
  padding: 5vh 20px;
  overflow: hidden;
}

.section-3-image {
  margin-top: 4vh;
  border-radius: 48px !important;
  box-shadow: 5px 7px 5.9px #00000040;
  width: 506px;
  height: 506px;
}

.section-3 p {
  margin: 3vh 0;
  font-family: 'Inter';
  font-size: clamp(24px, 20px, 15px); /* Improved responsiveness */
  font-weight: 700;
  font-size: 24px;
  line-height: 175%;
  letter-spacing: 0.05em;
  text-align: left;
  color: #fff;
  padding-bottom: 12vh;
  padding-left: 17vh;
}

.section-3 .ms-5 {
    margin-left: 1rem !important;
}

.section3-name h4 {
  font-family: 'Epilogue';
  font-size: clamp(28px, 4vw, 40px); /* Responsive font */
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  color: #fff;
}

.section3-name span {
  font-family: 'Archivo';
  font-size: clamp(20px, 3vw, 32px); /* Responsive font */
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  color: #fff;
}

@media (max-width: 1200px) {
  .section-3 p {
    margin-top: 6vh;
    text-align: left;
    padding-left: 2vh;
  }

  .section-3-image {
    margin-top: 6vh;
    max-height: 406px;
    width: auto;
    height: auto;
  }
}

@media (max-width: 767px) {
  .section-3 {
    padding: 5vh 15px;
  }

  .section-3 p {
    margin-top: 2vh;
    padding: 0 10px;
    text-align: center;
    padding-left: 0vh;
  }

  .section3-name h4, 
  .section3-name span {
    text-align: center;
  }
}

@media (max-width: 576px) {
  .section-3 {
    padding: 5vh 10px;
  }

  .section-3 p {
    font-size: clamp(16px, 4vw, 20px);
  }

  .section-3-image {
    width: 90%;
    margin-top: 4vh;
  }
}

@media (max-width: 576px) {
  .section-3 .order-sm-2 {
      order: 2 !important;
  }

  .section-3 .order-sm-1 {
      order: 1 !important;
  }
}


  /* Section 4 */
.section-4 {
  width: 100%;
  padding: 3rem 0%;
  position: relative;
  overflow: hidden;
  z-index: 2;
}

.section-4 .services{
  padding: 0vh 33vh;
}

.section-4 .services h5 {
  font-family: 'Epilogue';
  font-weight: 600;
  font-size: 64px;
  line-height: 84px;
  text-align: left;
}

.section-4 .services p {
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  text-align: right;
  color: #323743;
  font-family: 'Inter';
}
.section-4 .custom-card {
  display: flex;
  justify-content: center;
  /* flex-wrap: wrap; */
  gap: 4rem;

}

@media (max-width:1712px) {
  .section-4 .services{
    padding: 0vh 28vh;
  }
}

@media (max-width:1632px) {
  .section-4 .services{
    padding: 0vh 19vh;
  }
}

@media (max-width:1516px) {
  .section-4 .services{
    padding: 0vh 12vh;
  }
}

@media (max-width:1390px) {
  .section-4 .services{
    padding: 0vh 5vh;
  }
}

@media (max-width:1246px) {
  .section-4 .services{
    padding: 0vh 0vh;
  }
}

@media (max-width:1207px) {
  .section-4 .services{
    padding: 0vh 20vh;
  }
}

.section-4 .card {
  width: 100%;
  max-width: 360px;
  height: 528px; /* Fixed height */
  padding: 1.5rem;
  border-radius: 25px;
  background: #f3f4f6;
  border: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Align content */
}

.section-4 .card img {
  width: 100%;
  max-height: 240px; /* Ensure consistent image size */
  border-radius: 15px;
  object-fit: cover;
}

.section-4 .card:hover {
  transform: translateY(-8px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  background: #636ae8;
  color: #fff;
}

.section-4 .card-title {
  font-size: 1.5rem;
  font-family: 'Archivo', sans-serif;
}

.section-4 .card-text {
  font-size: 1rem;
  font-family: 'Inter', sans-serif;
  flex-grow: 1; /* Ensures equal height for card text */
}

.section-4 .know-more-btn {
/* border: 1px solid #1f27cd */
  color: #171a1f;
  transition: background-color 0.3s ease;
}

.section-4 .know-more-btn:hover {
  background: #636ae8;
  color: #fff;
}

/* Media Queries */
@media (max-width: 1200px) {
  .section-4 {
    padding: 2rem 5%;
  }

  .section-4 .services{
    padding: 0vh 13vh;
  }

  .section-4 .services h5 {
    font-size: 48px;
    /* text-align: center; */
  }

  .section-4 .services p {
    font-size: 18px;
    text-align: right;
  }

  .section-4 .custom-card {
    /* height: 500px; */
  }
}


@media (max-width: 1076px) {
  .section-4 .services{
    padding: 0vh 7vh;
  }
}


@media (max-width:991px) {
  .section-4 .services p {
    text-align: center;
  }

  .section-4 .services h5{
    text-align: center;
  }

}

@media (max-width:871px) {
  .section-4 .services{
    padding: 0vh 18vh;
  }
}

@media (max-width:427px) {
  .section-4 .card{
    height: auto;
  }
}

@media (max-width: 768px) {
  .section-4 {
    padding: 1.5rem 3%;
  }

  .section-4 .services h5 {
    font-size: 36px;
  }

  .section-4 .services p {
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .section-4 {
    padding: 1rem 11%;
  }

  .section-4 .services h5 {
    font-size: 28px;
  }

  .section-4 .services p {
    font-size: 14px;
  }

  .section-4 .card {
    max-width: 100%;
 
  }

  .section-4 .custom-card {
    padding: 0vh 1vh;
  }
  .section-4 .services{
    padding: 0vh 0vh;
  }
}

@media (max-width:469px) {
  .section-4 .custom-card {
    /* padding: 0vh 3vh; */
  }
}

@media (max-width:343px) {
  .section-4 .custom-card {
    padding: 0vh;
  }
}
  /* section 5 */

  .section-5{
    height: 100%; 
    overflow: hidden;
    position: relative;
  }

  .marquee-container {
    width: 100%;
    height: auto; /* Adjust height */
    overflow: hidden;
    position: relative;
    background-color: #ffff; /* Optional background */
    margin-top: 88px;
  }

  /* Moving content */
  .marquee-content {
    width: 140%; /* Double the container width for smooth scroll */
    position: absolute;
    animation: scrollBothSides 10s linear infinite alternate;
  }

  /* Image styling */
  .marquee-content img {
    width: 100%; /* Stretch to fit */
    height: 100%;
    object-fit: cover;
  }

  /* Keyframe Animation: Bi-directional scroll */
  @keyframes scrollBothSides {
    0% {
      left: 0; /* Start from left */
    }
    100% {
      left: -40%; /* Move to right */
    }
  }

  .single-image-slider{
    display: none;
  }

  @media (max-width:1953px) {
    .marquee-container {
      height: auto;
    }
  }

  @media (max-width:1953px) {
    .marquee-container {
      height: 90vh;
    }
  }

  @media (max-width:969px) {
    .marquee-container {
      height: 65vh;
    }
  }

  @media (max-width:1024px) {
    .marquee-container {
      height: 42vh;
    }
  }

  @media (max-width:840px) {
    .section-5 .marquee-container{
        display: none;
      }

      .marquee-container-small {
        margin-top: 40px;
        width: 100%;
        /* height: 100vh;  */
        overflow: hidden;
        position: relative;
        background-color: #fff; /* Optional background */
        padding: 10px 0;
        }

        /* Content that scrolls */
        .marquee-content-small {
        display: flex;
        gap: 20px; /* Add gaps between images */
        animation: scrollInfinite 10s linear infinite;
        }

        /* Individual image item */
        .marquee-item-small {
        flex: 0 0 auto; /* Prevent shrinking and maintain size */
        }

        .marquee-image-small {
        width: 300px;
        height: 300px;
        object-fit: cover;
        border-radius: 10px; /* Optional rounded corners */
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Optional shadow */
        }

        /* Keyframes for infinite scrolling */
        @keyframes scrollInfinite {
        from {
          transform: translateX(0);
        }
        to {
          transform: translateX(-100%);
        }
        }
  }

  @media (max-width:840px) {

      .single-image-slider{
        display: flex;
      }
      .marquee-container {
        width: 100%;
        height: 400px; /* Adjust height as needed */
        overflow: hidden;
        position: relative;
        background-color: #f0f0f0; /* Optional background */
      }

      /* Moving content: duplicate image for seamless effect */
      .marquee-content {
        display: flex;
        width: 200%; /* Double the width for continuous scrolling */
        animation: scrollLeftToRight 10s linear infinite;
      }

      /* Image styling */
      .marquee-content img {
        width: 100%; /* Stretch to fit half the container */
        height: 100%;
        object-fit: cover;
      }


  }

  /* section 6 */

  /* .section-6{
    width: 100%;
    height: 100vh; 
    overflow: hidden;
    position: relative;
    z-index: 2; 
    padding: 3rem 15rem 0rem 15rem; 
  }

  .section-6 .title h5{
    font-family: 'Archivo';
    font-size: 64px;
  }


  .section-6 .custom-card{
    background: #636AE8;
    
  }

  .section-6 .custom-card{
    height: 55vh;
    padding: 3rem 6rem 6rem 6rem;
  }

  .section-6 .swiper{
    height: 47vh;
  } */

  .section-6 {
    width: 80%; /* 80% of the container */
    margin: 0 auto; /* Center the section horizontally */
    padding: 2rem 0; /* Adjust padding */
    position: relative; /* Ensure proper positioning */
    display: none;
  }

  .section-6 .swiper {
    width: 100%; /* Make Swiper take full width of section */
    padding: 0px 3vh 3rem 3vh;

  }

  .section-6 .swiper-pagination {
    position: relative; /* Move pagination out of the card */
    bottom: -10px; /* Adjust to place below cards */
    text-align: center; /* Center-align the dots */
  }

  .section-6 .card-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .section-6 .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto; /* Ensure slides adapt to content */
  }

  /* Adjust individual bullet size */
  .section-6 .swiper-pagination.swiper-pagination-horizontal .swiper-pagination-bullet {
    width: 30px !important;  /* Adjust the width */
    height: 30px !important; /* Adjust the height */
    background-color: #636AE8 !important; /* Change the dot color */
    opacity: 1 !important; /* Make dots fully visible */
  }

  /* Active dot styling */
  .section-6 .swiper-pagination.swiper-pagination-horizontal .swiper-pagination-bullet-active {
    background-color: #fff !important; /* Color for active dot */
    transform: scale(1.3) !important; /* Slightly enlarge active dot */
  }


  .section-6 .custom-card {
    width: 100%; /* Make card take full width of the slide */
    height: auto; /* Adjust height dynamically */
    padding: 1rem; /* Reduce padding for smaller screens */
    background: #636AE8; /* Retain card color */
    border-radius: 15px;
  }

  .section-6 .card-img-top {
    width: 100%; /* Ensure the image scales correctly */
    height: auto;
    object-fit: cover; /* Maintain aspect ratio */
  }

  .section-6 .title h5 {
    font-family: 'Archivo';
    font-size: clamp(28px, 5vw, 64px); /* Responsive font size */
    text-align: center;
  }

  @media (min-width: 768px) {
    .section-6 .custom-card {
      padding: 1.5rem;
    }
  }

  @media (min-width: 1200px) {
    .section-6 .custom-card {
      padding: 2rem;
    }
  }


  </style>


